import React from 'react';
import LegalLayout from './LegalLayout';

const Privacy = () => {
    return (
        <LegalLayout title="Privacy Policy" lastUpdated="30th Jan 2026">
            <p>This Privacy Policy explains how Trend Ads (“we,” “us,” “our”) collects, uses, shares, and protects information when you use trendads.ai and related services (the “Service”).</p>

            <h2>1) Information we collect</h2>
            <p>We may collect:</p>

            <h3>A. Information you provide</h3>
            <ul>
                <li>Account details (name, email, username, organization, role)</li>
                <li>Advertiser details (billing contact, company info)</li>
                <li>Support requests and communications</li>
            </ul>

            <h3>B. Wallet and blockchain-related information (if you connect a wallet)</h3>
            <ul>
                <li>Public wallet address</li>
                <li>On-chain transaction identifiers (e.g., transaction hash) related to rewards/payouts or verification</li>
            </ul>
            <p>Note: blockchain data may be public and independently accessible.</p>

            <h3>C. Automatically collected data</h3>
            <ul>
                <li>Device info (IP address, browser type, OS)</li>
                <li>Usage data (ad interactions, session duration, clicks)</li>
                <li>Cookies and similar tracking technologies for functionality and analytics</li>
            </ul>

            <h2>2) How we use information</h2>
            <ul>
                <li>Provide and operate the Service</li>
                <li>Measure and report performance</li>
                <li>Prevent fraud, abuse, and security incidents</li>
                <li>Improve and optimize targeting and delivery</li>
                <li>Communicate with you</li>
                <li>Comply with legal obligations</li>
            </ul>

            <h2>3) How we share information</h2>
            <ul>
                <li><strong>Service providers/processors:</strong> Partners who process data for us (e.g., hosting, analytics).</li>
                <li><strong>Advertisers and publishers:</strong> Aggregated or de-identified reporting.</li>
                <li><strong>Blockchain networks:</strong> Public transaction data.</li>
                <li><strong>Legal and safety:</strong> If required by law or to protect rights and security.</li>
            </ul>

            <h2>4) Legal bases (EEA/UK where applicable)</h2>
            <ul>
                <li>Contract necessity</li>
                <li>Legitimate interests</li>
                <li>Consent</li>
                <li>Legal obligation</li>
            </ul>

            <h2>5) Data retention</h2>
            <p>We keep your information as long as necessary for the purposes above or as required by law.</p>

            <h2>6) Security</h2>
            <p>We implement technical and organizational measures to protect your data, but no online platform is 100% secure.</p>

            <h2>7) International transfers</h2>
            <p>Your data may be transferred to and processed in countries outside your own. We use appropriate safeguards for such transfers.</p>

            <h2>8) Your rights</h2>
            <p>Depending on your location, you may have the right to access, correct, delete, or restrict the use of your data. Contact us to exercise these rights.</p>

            <h2>9) Children’s privacy</h2>
            <p>The Service is for users 18+. We do not knowingly collect information from children.</p>

            <h2>10) Third-party links</h2>
            <p>We are not responsible for the privacy practices of third-party sites linked from our Service.</p>

            <h2>11) Changes to this policy</h2>
            <p>We will notify you of any material changes by posting the new policy on the site.</p>

            <h2>12) Contact</h2>
            <p>Trendads.ai<br />Privacy contact: support@trendcreator.io</p>
        </LegalLayout>
    );
};

export default Privacy;
